import { Tabs } from 'antd'
import { useEffect, useState } from 'react'
import {
    createSearchParams,
    useNavigate,
    useSearchParams,
} from 'react-router-dom'

import { BitazzaText } from '../../../components'
import { Performance, Statistics } from './'
import { useTranslation } from 'react-i18next'

interface Props {
    performance?: performanceRequest
}

export const ProfileTabs: React.FC<Props> = ({ performance }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [activeKey, statsActiveKey] = useState<string>('performance')
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        if (searchParams.get('statistic')) {
            statsActiveKey('Statistics')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams.get('statistic')])

    const items = [
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content={t('txt_performance')}
                    format="tab"
                    style={{ width: '120px' }}
                    textTransform="uppercase"
                />
            ),

            key: 'performance',
            children: <Performance cumulativePerf={performance} />,
        },
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content={t('txt_statistics')}
                    format="tab"
                    style={{ width: '120px' }}
                />
            ),

            key: 'Statistics',
            children: <Statistics performance={performance} />,
        },
    ]

    const onTabHandler = (tab: string) => {
        const noHeader = searchParams.get('noheader')

        if (searchParams.get('search') && tab === 'Statistics') {
            navigate({
                pathname: '/my-profile',
                search: createSearchParams({
                    statistic: 'true',
                    search: searchParams.get('search') as string,
                    ...(noHeader ? { noheader: noHeader } : {}),
                }).toString(),
            })
        } else if (tab === 'Statistics') {
            navigate({
                pathname: '/my-profile',
                search: createSearchParams({
                    statistic: 'true',
                    ...(noHeader ? { noheader: noHeader } : {}),
                }).toString(),
            })
        } else {
            searchParams.delete('statistic')
            setSearchParams(searchParams)
        }

        statsActiveKey(tab)
    }
    return (
        <Tabs
            items={items}
            onChange={onTabHandler}
            activeKey={activeKey}
            tabBarGutter={100}
            centered
        />
    )
}
